/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { FC, useCallback, useEffect, useState } from 'react'

import { Button } from '@components/Button'
import useMain from '@hooks/useMain'
import useNetworkWallet from '@hooks/useNetworkWallet'
import useStoreNetworkWallet from '@store/networkWalletStore'
import { IInventory, IInventoryItem } from '@types'

import { InventorySelectedItem, InventorySliderPreview } from './components'
import { InventoryEmpty, InventoryEmptyMessage } from './index.style'

const defaultInventoryData = {
    collectionName: '',
    items: [],
    totalItems: 0,
}

export const InventoryPage: FC = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [inventoryData, setInventoryData] = useState<IInventory>(defaultInventoryData)
    const [itemSelected, setItemSelected] = useState<IInventoryItem>()

    const {
        state: {
            mainInit: { contractAddress },
            currentStep,
        },
        operations: { setCurrentStep },
    } = useMain()

    const { networkManager } = useStoreNetworkWallet()

    const {
        state: { currentWalletAddress },
    } = useNetworkWallet()

    const handleGetNfts = useCallback(async () => {
        let nfts: IInventory | undefined
        // eslint-disable-next-line unicorn/prefer-ternary
        if (currentStep === 'inventory-useWinter') {
            nfts = await networkManager.getNfts([], currentWalletAddress!, 'useWinter')
        } else {
            nfts = await networkManager.getNfts(contractAddress, currentWalletAddress!, 'alchemy')
        }

        if (nfts) {
            setInventoryData(nfts)
            if (nfts.totalItems) setItemSelected(nfts.items[0])
        }

        setIsLoading(false)
    }, [contractAddress, currentStep, currentWalletAddress, networkManager])

    useEffect(() => {
        if (isLoading) handleGetNfts()
    }, [isLoading])

    const handleClickItem = useCallback(
        (index: number) => () => {
            const item = inventoryData.items[index]
            setItemSelected(item)
        },
        [inventoryData.items],
    )

    const handleRedirectHome = useCallback(() => {
        setCurrentStep('home-multiple-sales-behaviour')
    }, [setCurrentStep])

    if (isLoading) return <div>Loading...</div>
    if (!itemSelected)
        return (
            <InventoryEmpty>
                <InventoryEmptyMessage>You {`haven't`} minted any NFT from this collection yet.</InventoryEmptyMessage>
                <Button circle color="tertiary" onClick={handleRedirectHome}>
                    MINT ONE NOW
                </Button>
            </InventoryEmpty>
        )

    return (
        <>
            <InventorySelectedItem item={itemSelected} />
            <InventorySliderPreview
                collectionName={inventoryData.collectionName}
                items={inventoryData.items}
                onChange={handleClickItem}
            />
        </>
    )
}
